import React, { ComponentProps } from "react";

import { FileUpload } from "src/components/FileUpload";
import { useFieldContext } from "src/hooks";

import { FormControl } from "../FormControl";

interface Props extends ComponentProps<typeof FormControl> {
  placeholder: string;
  maxFiles: number;
}

export const FileUploadField = ({ label, placeholder, maxFiles }: Props) => {
  const field = useFieldContext<Array<File> | null>();

  return (
    <FormControl label={label}>
      <FileUpload
        placeholder={placeholder}
        onChange={field.handleChange}
        documents={field.state.value}
        maxFiles={maxFiles}
        isLoading={false}
        isSuccess // force success state to display documents previews
      />
    </FormControl>
  );
};
